export const LEAD_CACHE_KEY = "lead_detail_cache_v1";
export const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function extractLeadUuid(value) {
  const raw = String(value || "").trim();
  if (!raw) return null;
  const match = raw.match(UUID_RE);
  return match ? match[0] : null;
}

export function getLeadRouteId(lead, idx = 0) {
  const directId = extractLeadUuid(lead?.id);
  if (directId) return directId;
  const parts = [
    lead?.id,
    lead?.county_name,
    lead?.property_address,
    lead?.date,
    lead?.file_date,
    idx,
  ].filter(Boolean);
  return encodeURIComponent(parts.join("-").replace(/\s+/g, "-"));
}
